module.exports = __webpack_public_path__ + "img/com7-wh.45c86547.svg";